/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [""];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/reports/print-dialog/print-dialog.component.scss.shim.ngstyle.js.pre-build-optimizer.js